/**
 * external-links.js
 * Makes all external links open in a new tab.
 *
 * An "external" link is any http(s) anchor whose hostname differs from the
 * current store's hostname. Mailto, tel, anchor (#), and same-site links are
 * left untouched. Adds rel="noopener noreferrer" for security/performance.
 *
 * Runs on load and watches for links added later (cart drawer, quick view,
 * AJAX-loaded sections) via a MutationObserver.
 */
(function () {
  'use strict';

  var PROCESSED_ATTR = 'data-external-handled';

  function isExternal(anchor) {
    // Only handle http/https links with a different hostname.
    if (anchor.protocol !== 'http:' && anchor.protocol !== 'https:') return false;
    return anchor.hostname !== window.location.hostname;
  }

  function process(anchor) {
    if (anchor.hasAttribute(PROCESSED_ATTR)) return;
    anchor.setAttribute(PROCESSED_ATTR, '');

    if (!isExternal(anchor)) return;

    anchor.setAttribute('target', '_blank');

    // Preserve any existing rel tokens, then ensure noopener/noreferrer.
    var rel = (anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    ['noopener', 'noreferrer'].forEach(function (token) {
      if (rel.indexOf(token) === -1) rel.push(token);
    });
    anchor.setAttribute('rel', rel.join(' '));
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href]').forEach(process);
  }

  function init() {
    scan(document);

    // Catch links injected after initial render.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'A') {
              process(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('a[href]').forEach(process);
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
